<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../../components/widgets/loader";
import Forms from "../../../../mixins/Forms";

import axios from 'axios';

/**
 * View ticket note templates component
 */
export default {
  page: {
    title: "SLA Settings",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Forms],
  components: {Layout, PageHeader, Loader},
  data() {
    return {
      title: "SLA Settings",
      items: [
        {
          text: "Settings",
          href: "#"
        },
        {
          text: "SLA Settings",
          active: true
        }
      ],

      isLoading: false,
      isSaving: false,
      slaSettings: null,
      slaEditing: null,
      slaEditValue: null,
      serverErrors: []
    };
  },
  computed: {
   editModalTitle() {
     if (this.slaEditing) {
        return 'Edit ' + this.formatKey(this.slaEditing) + ' Priority SLA';
     }
     return 'Edit SLA';
   }
  },
  methods: {
    loadSlaSettings() {
      let vm = this;
      vm.isLoading = true;
      axios.get(API_BASE + '/settings/slas').then(r => {
        vm.isLoading = false;
        vm.slaSettings = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    },

    edit(key) {
     this.slaEditing = key;
     this.slaEditValue = this.slaSettings[key];
      this.$bvModal.show('edit-sla-modal');
    },

    saveChanges() {
      let vm = this;
      vm.isSaving = true;
      let slas = {
        ...this.slaSettings,
      }
      slas[this.slaEditing] = this.slaEditValue;

      axios.put(API_BASE + '/settings/slas', slas).then(r => {
        vm.isSaving = false;
        vm.loadSlaSettings();
        this.$notify.success({
          title: 'Success!',
          message: 'SLA updated successfully',
        });
        vm.$bvModal.hide('edit-sla-modal');
      }).catch(e => {
        console.log(e);
        vm.isSaving = false;
        vm.setErrors(e);
      });
    },

    formatKey(key) {
      switch (key) {
        case 'low_priority_sla':
          return 'Low';
        case 'medium_priority_sla':
          return 'Medium';
        case 'high_priority_sla':
          return 'High';
        case 'urgent_priority_sla':
          return 'Urgent';
        default:
          return key;
      }
    }
  },
  created() {
    this.loadSlaSettings();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="isLoading" class="text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>

            <div v-if="!isLoading" class="table-responsive mb-0">

              <!-- Table -->
              <table class="table mb-0 table-centered">
                <thead class="thead-light">
                <tr>
                  <th>Priority</th>
                  <th>SLA (Minutes)</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(sla, key) in slaSettings">
                  <th scope="row">{{ formatKey(key) }}</th>
                  <td>{{ sla }}</td>
                  <td class="text-right">
                    <!-- Button trigger modal -->
                    <button @click.prevent="edit(key)"
                        type="button"
                        class="btn btn-itg btn-sm"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
                <tr v-if="slaSettings.length === 0">
                  <th scope="row" colspan="3">
                    <span class="text-danger">No results</span>
                  </th>
                </tr>
                </tbody>
              </table>
              <!-- / Table -->

              <!-- Edit Modal-->
              <b-modal id="edit-sla-modal" no-close-on-backdrop :title="editModalTitle" hide-footer>
                <loading-screen :is-loading="isSaving"></loading-screen>
                <errors :error-list="serverErrors"></errors>

                <div>

                    <div class="form-group mb-4">
                      <label for="edit-sla-field">SLA (Minutes)</label>
                      <input @keyup.enter="saveChanges" y id="edit-sla-field" type="text" class="form-control" v-model="slaEditValue" />
                    </div>

                  <a href="#" @click.prevent="saveChanges" class="btn btn-itg-dark">Save</a>

                </div>
              </b-modal>
              <!-- / Edit Modal -->

            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
